import './Personalize.css'
import PersonalizeItemCard from './PersonalizeItemCard/PersonalizeItemCard'
import { PERSONALIZE_LIST } from '../../../utils/constants/PersonaliseDashboard'
import { getHNIReports } from 'src/services/individualService'
import { COLORS } from 'src/utils/Themes/colors'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { showNotificationMessage } from 'src/actions'
import LoadingModal from 'src/components/common/LoadingModal'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import {
  NOTIFICATION_SETTINGS_MSG,
  REPORT_DOWNLOAD,
} from 'src/utils/constants/Individual'

const Personalize = () => {
  const dispatch = useDispatch()
  // eslint-disable-next-line
  const classes = useStyles()
  const userInfo = useSelector((state) => state?.userInfo)

  const [loading, setLoading] = useState(false)
  const [hniData, setHniData] = useState({})

  const fetchHNIReports = async (token) => {
    setLoading(true)

    const response = await getHNIReports(token, userInfo?.userName)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_SETTINGS_MSG?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData) {
        setHniData(responseData)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_SETTINGS_MSG?.NO_REPORTS,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: NOTIFICATION_SETTINGS_MSG?.ENCOUNTERED_ERROR_ON_REPORTS,
        })
      )
    }
  }
  function hasNoUploadedFile(data) {
    return Object.values(data)?.every(
      (value) => Array.isArray(value) && value?.length === 0
    )
  }

  useEffect(() => {
    fetchHNIReports()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={'personalize-container'}>
      <LoadingModal loading={loading} />
      <div className={'personalise-heading'}>Personalise</div>
      <div className={'personalise-list-container'}>
        {PERSONALIZE_LIST.map((personaliseListItem) => {
          if (
            personaliseListItem?.type === REPORT_DOWNLOAD &&
            hasNoUploadedFile(hniData)
          ) {
            // Skip this item if the type is REPORT_DOWNLOAD and the report data is empty
            return null
          } else
            return (
              <div key={`personaliseCard_${personaliseListItem?.type}`}>
                <PersonalizeItemCard
                  itemDetails={personaliseListItem}
                  reportData={hniData}
                />
              </div>
            )
        })}
      </div>

      {/* <ComingEvents />*/}
    </div>
  )
}

export default Personalize

const useStyles = makeStyles({
  menuButton: {
    textTransform: 'unset',
    fontSize: '10px',
    width: '150px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
    background: COLORS.DARK_PINK,
    color: COLORS.WHITE,
    height: '24px',
    padding: '5px 15px !important',
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: COLORS.DARK_PINK,
    },
    lineHeight: '0.5',
  },
  modalContent: {
    textAlign: 'center',
    padding: '24px',
    height: 'calc(100% - 48px)',
    overflow: 'auto',
  },
  modalRoot: {
    height: '90%',
  },
})
